// Нужно ли сейчас показать экран разрешения на передачу данных AI.
//
// Чистая функция, а не условие внутри `AuthFlowGate`: у шага пять входов, и
// каждый из них — отдельный способ либо спросить не вовремя (поверх экрана
// документов, офлайн без возможности записать ответ), либо не спросить вовсе.
// Второе — ровно то, за что App Store завернул сборку 17.09.2026.

import { underPrefix } from "./auth-flow-target";

export interface AiDataSharingStepState {
	/** Сборка приложения (Capacitor). На вебе основание — принятый дисклеймер. */
	isNativeApp: boolean;
	userId: string | null;
	/** На этой установке этого пользователя уже спросили. */
	askedOnThisInstall: boolean;
	isOffline: boolean;
	isLoading: boolean;
	pendingConsent: boolean;
	iecLegalPending: boolean;
	pathname: string;
}

/**
 * Юр-страницы (на дисклеймер ведёт ссылка с самого экрана) и возврат из входа
 * экран не перекрывает.
 */
const AI_DATA_SHARING_EXEMPT_PREFIXES = ["/legal/", "/auth/"] as const;

export function needsAiDataSharingStep(state: AiDataSharingStepState): boolean {
	if (!state.isNativeApp || state.userId === null) return false;
	if (state.askedOnThisInstall) return false;
	// Офлайн ответ не записать, а без сети и отправлять нечего.
	if (state.isOffline || state.isLoading) return false;
	// Документы — раньше: экран ссылается на дисклеймер как на основание.
	if (state.pendingConsent || state.iecLegalPending) return false;
	return !underPrefix(state.pathname, AI_DATA_SHARING_EXEMPT_PREFIXES);
}
